import $ from 'jquery';

const noop = () => {};

const toArray = (value) => {
    if (Array.isArray(value)) {
        return value;
    }

    if (!value) {
        return [];
    }

    return [value];
};

export const createModalController = (config = {}) => {
    const {
        popupSelector,
        modalInnerSelector,
        openTriggerSelector,
        closeTriggerSelector = [],
        readyClass = 'ready',
        openClass = 'open',
        closeOnOverlayClick = true,
        closeOnEscape = true,
        lockScroll = false,
        initialFocusSelector,
        onOpen = noop,
        onClose = noop,
    } = config;

    if (!popupSelector) {
        return null;
    }

    const popup = $(popupSelector);
    if (!popup.length) {
        return null;
    }

    const innerSelector = modalInnerSelector || `${popupSelector}__inner`;
    const closeSelectors = toArray(closeTriggerSelector);
    const openTriggers = openTriggerSelector ? $(openTriggerSelector) : $();
    let lastFocusedElement = null;
    let previousOverflow = '';

    const toggleScrollLock = (isOpen) => {
        if (!lockScroll) {
            return;
        }

        if (isOpen) {
            previousOverflow = document.documentElement.style.overflow;
            document.documentElement.style.overflow = 'hidden';
            return;
        }

        document.documentElement.style.overflow = previousOverflow;
    };

    const updateAccessibilityState = (isOpen) => {
        popup.attr('aria-hidden', isOpen ? 'false' : 'true');
        openTriggers.attr('aria-expanded', isOpen ? 'true' : 'false');
    };

    const focusModal = () => {
        const initialFocus = initialFocusSelector
            ? popup.find(initialFocusSelector).first()
            : popup.find(innerSelector).first();

        if (!initialFocus.length) {
            return;
        }

        window.requestAnimationFrame(() => {
            initialFocus.trigger('focus');
        });
    };

    const showPopup = (event) => {
        if (event) {
            event.preventDefault();
        }

        lastFocusedElement = document.activeElement;
        popup.addClass(openClass);
        updateAccessibilityState(true);
        toggleScrollLock(true);
        onOpen(popup);
        focusModal();
    };

    const hidePopup = (event) => {
        if (event) {
            event.preventDefault();
        }

        popup.removeClass(openClass);
        updateAccessibilityState(false);
        toggleScrollLock(false);
        onClose(popup);

        if (lastFocusedElement && typeof lastFocusedElement.focus === 'function' && lastFocusedElement.isConnected) {
            lastFocusedElement.focus();
        }
    };

    updateAccessibilityState(false);

    if (document.readyState === 'complete') {
        popup.addClass(readyClass);
    } else {
        $(window).on('load', () => {
            popup.addClass(readyClass);
        });
    }

    if (openTriggerSelector) {
        $(document).on('click', openTriggerSelector, showPopup);
    }

    closeSelectors.forEach((selector) => {
        $(document).on('click', selector, hidePopup);
    });

    if (closeOnOverlayClick) {
        popup.on('click', (event) => {
            const clickedInsideInner = $(event.target).closest(innerSelector).length > 0;
            if (!clickedInsideInner) {
                hidePopup(event);
            }
        });
    }

    if (closeOnEscape) {
        $(document).on('keydown', (event) => {
            if (event.key === 'Escape' && popup.hasClass(openClass)) {
                hidePopup();
            }
        });
    }

    return {
        showPopup,
        hidePopup,
        popup,
    };
};
